import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("a", {
        class: "btn btn-quadrado shadow-none",
        href: _ctx.hrefReal,
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onClick($event))
    }, [
        _createElementVNode("i", {
            class: _normalizeClass(_ctx.menu.icone)
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.menu.nome), 1)
    ], 8, _hoisted_1));
}
